module.exports = __webpack_public_path__ + "static/media/GBR Tech Farmers Infographic desktop - GBR Tech - 14-05-2024 N.935d8908.gif";